module.exports = __webpack_public_path__ + "img/logoTimelysoft.c55b9422.png";